import React from "react";
import { TransactionSubTab } from "../types";
import {
  AllTypeIcon,
  CrossBorderIcon,
  EuFlagIcon,
  FinancePaymentIcon,
  GbFlagIcon,
  GlobeIcon,
  InvoicePaymentIcon,
  NgFlagIcon,
  OrderPaymentIcon,
  SameCurrencyIcon,
  ShipmentPaymentIcon,
  UsdcIcon,
  UsdtIcon,
  UsFlagIcon,
  WalletConversionIcon,
  WalletFundingIcon,
} from "./filterIcons";
import { SelectOption } from "../../../shared/ui";

export const currencySelectorOptions = [
  { label: "NG Naira", value: "NGN", icon: "🇳🇬" },
  { label: "US Dollar", value: "USD", icon: "🇺🇸" },
  { label: "GB Pound", value: "GBP", icon: "🇬🇧" },
  { label: "Euro", value: "EUR", icon: "🇪🇺" },
];

export const timeFilterOptions = [
  { label: "All Time", value: "all" },
  { label: "Today", value: "day" },
  { label: "Past 1 week", value: "week" },
  { label: "Past 1 month", value: "month" },
  { label: "Past 1 year", value: "year" },
];

export const sortOptions: SelectOption[] = [
  { label: "Recent first", value: "recent" },
  { label: "Oldest first", value: "oldest" },
  { label: "Customer: A - Z", value: "customer-asc" },
  { label: "Customer: Z - A", value: "customer-desc" },
  { label: "Provider: A - Z", value: "provider-asc" },
  { label: "Provider: Z - A", value: "provider-desc" },
  { label: "Counterparty: A - Z", value: "counterparty-asc" },
  { label: "Counterparty: Z - A", value: "counterparty-desc" },
  { label: "Highest amount first", value: "highest" },
  { label: "Lowest amount first", value: "lowest" },
];

export const tableCurrencyOptions: SelectOption[] = [
  { label: "All", value: "All", icon: React.createElement(GlobeIcon) },
  { label: "NG Naira", value: "NGN", icon: React.createElement(NgFlagIcon) },
  { label: "US Dollars", value: "USD", icon: React.createElement(UsFlagIcon) },
  { label: "GB Pounds", value: "GBP", icon: React.createElement(GbFlagIcon) },
  { label: "Euro", value: "EUR", icon: React.createElement(EuFlagIcon) },
  { label: "USD Coin", value: "USDC", icon: React.createElement(UsdcIcon) },
  { label: "USD Tether", value: "USDT", icon: React.createElement(UsdtIcon) },
];

export const typeFilterOptions: SelectOption[] = [
  { label: "All", value: "All", icon: React.createElement(AllTypeIcon) },
  {
    label: "Wallet funding",
    value: "Wallet funding",
    icon: React.createElement(WalletFundingIcon),
  },
  {
    label: "Wallet conversion",
    value: "Wallet conversion",
    icon: React.createElement(WalletConversionIcon),
  },
  {
    label: "Same currency transfer",
    value: "Same currency transfer",
    icon: React.createElement(SameCurrencyIcon),
  },
  {
    label: "Cross border transfer",
    value: "Cross border transfer",
    icon: React.createElement(CrossBorderIcon),
  },
  {
    label: "Invoice payment",
    value: "Invoice payment",
    icon: React.createElement(InvoicePaymentIcon),
  },
  {
    label: "Finance payment",
    value: "Finance payment",
    icon: React.createElement(FinancePaymentIcon),
  },
  {
    label: "Order payment",
    value: "Order payment",
    icon: React.createElement(OrderPaymentIcon),
  },
  {
    label: "Shipment payment",
    value: "Shipment payment",
    icon: React.createElement(ShipmentPaymentIcon),
  },
];

export const subTabsConfig: Array<{ label: TransactionSubTab; count?: number }> = [
  { label: "All", count: undefined },
  { label: "Flagged", count: undefined },
  { label: "Pending", count: undefined },
  { label: "Failed", count: undefined },
  { label: "Completed", count: undefined },
];
